import { IMachineNotifications, IMachineNotificationsStopped, INotifications } from '@app/@introspection';
import { Inject } from '@rxdi/core';
import { Component, html, LitElement, property } from '@rxdi/lit-html';
import { ComputerIcon } from '@shared/icons';

import { DateTimeProvider } from '../../date-time/date-time.service';

export const isMachineStoppedNotification = (n: INotifications) =>
  n.data.__typename === 'MachineNotifications' && n.data.message.__typename === 'MachineNotificationsStopped';

/**
 * @customElement machine-stopped-template-notifications
 */
@Component({
  selector: 'machine-stopped-template-notifications',
  template(this: MachineStoppedTemplateComponent) {
    const data = this.notification.data as IMachineNotifications;
    const message = data.message as IMachineNotificationsStopped;
    return html`
      <style>
        .spacer {
          flex: 1 3 auto;
        }
      </style>
      <div part="width" style="font-size: 12px; display: flex">
        <div style="margin-right: 13px; font-size: 22px; width: 45px">
          <!-- &#128187 -->
          ${ComputerIcon}
        </div>
        <div style="width: 100%;">
          <div style="min-height: 20px;">
            <span style="color: red; font-weight: 500">Stopped</span> Linode
            <a style="color: blue">${message.ip}</a>
            type
            <a style="color: blue">${message.worker_type}</a>
          </div>

          <div style="display: flex; margin-top: 5px;">
            <div>${this.dateTimeProvider.getDate(this.notification.createdAt)}</div>
            <span class="spacer"></span>
            <div>${this.dateTimeProvider.getHours(this.notification.createdAt)}</div>
          </div>
        </div>
      </div>
    `;
  },
})
export class MachineStoppedTemplateComponent extends LitElement {
  @Inject(DateTimeProvider) private dateTimeProvider: DateTimeProvider;

  @property({ type: Object }) notification: INotifications;
}
